import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f8b6c3ba&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=f8b6c3ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b6c3ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8b6c3ba')) {
      api.createRecord('f8b6c3ba', component.options)
    } else {
      api.reload('f8b6c3ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f8b6c3ba&scoped=true", function () {
      api.rerender('f8b6c3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/agent/index.vue"
export default component.exports